import {METHOD} from "./method";

export const API_USER = {
    CREATE: {
        api: '/v1/dashboard-admin/user',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/user',
        method: METHOD.PUT,
    },
    DETAILS: {
        api: '/v1/dashboard-admin/user',
        method: METHOD.GET,
    },
    LIST: {
        api: '/v1/dashboard-admin/user/list',
        method: METHOD.POST,
    },
    EXPORT: {
        api: '/v1/dashboard-admin/user/list/export',
        method: METHOD.POST,
    },
    CHANGE_PASSWORD: {
        api: '/v1/dashboard-admin/user/change-password',
        method: METHOD.POST,
    },
    ADDRESS: {
        api: '/v1/dashboard-admin/user/address',
        method: METHOD.GET,
    },
    BEAUTY_PROFILE: {
        api: '/v1/dashboard-admin/user/beauty-profile',
        method: METHOD.GET,
    },
    WISHLIST: {
        api: '/v1/dashboard-admin/user/wishlist',
        method: METHOD.GET,
    },
    WAITLIST: {
        api: '/v1/dashboard-admin/user/waitlist',
        method: METHOD.GET,
    },
    BULK_CHANGE_STATUS: {
        api: '/v1/dashboard-admin/user/bulk-action',
        method: METHOD.POST,
    },
    URL_UPLOAD_IMAGES: {
        api: '/v1/dashboard-admin/user/storage-url/attachment',
        method: METHOD.POST,
    },
    ROLE_LIST: {
        api: '/v1/dashboard-admin/user/roles',
        method: METHOD.GET,
    },
    ORDER_LIST: {
        api: '/v1/dashboard-admin/user/order',
        method: METHOD.GET,
    },
    EXPORT_ORDER: {
        api: '/v1/dashboard-admin/user/order/export',
        method: METHOD.POST,
    },
    REVIEW_LIST: {
        api: '/v1/dashboard-admin/user/review',
        method: METHOD.GET,
    },
    POINT_HISTORY: {
        api: '/v1/dashboard-admin/user/loyalty-point',
        method: METHOD.GET,
    },
}
